// MAJLIS-164 (ruling 1): the few Arabic words the ENGLISH interface prints beside its own, as the approved mock-ups
// draw it (the Listen sheet's title and option lines, UI-C21; the behind marker, UI-C23; the mic hint, UI-C24). They
// live here, in the main bundle, so the Arabic catalogue itself stays a lazy chunk. catalogueImports.test.ts holds each
// of the catalogue-backed ones equal to the Arabic catalogue's own value (the catalogue stays the one source).
import type { StringKey } from "./catalogues/en";

/** The Arabic catalogue's value of each key the English interface shows beside its own words. */
export const AR_BESIDE_EN = {
  listenTitle: "الاستماع",
  behind: "متأخر {n}",
  micListening: "الميكروفون متوقف أثناء الاستماع — اضغط للتحدث",
} as const satisfies Partial<Record<StringKey, string>>;

/** MAJLIS-64 (UI-C21): the Arabic line the approved mock-up prints under each ENGLISH option of the Listen sheet,
 * verbatim. Shown only in the English interface; the Arabic interface's options are the Arabic catalogue's. */
export const MOCKUP_ARABIC_LINES = {
  listenTranslated: "مترجم — تُقرأ لك العبارات بلغتك، والأصوات الحية منخفضة تحتها",
  // iOS (consultant ruling 2026-09-23): the same line with the live voices MUTED, «والأصوات الحية مكتومة تحتها».
  listenTranslatedIOS: "مترجم — تُقرأ لك العبارات بلغتك، والأصوات الحية مكتومة تحتها",
  listenOriginal: "الأصلي — الأصوات الحقيقية فقط، والترجمة نصّاً",
} as const;
